import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import dashboardService from "./dashboardService";

export const getDashboardOverview = createAsyncThunk(
  "dashboard/getDashboardOverview",
  async (_, thunkAPI) => {
    try {
      return await dashboardService.getDashboardOverview();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message,
      );
    }
  },
);

const initialState = {
  overview: null,
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",

  initialState,

  reducers: {
    clearDashboardError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getDashboardOverview.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })

      .addCase(getDashboardOverview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.overview = action.payload?.data || action.payload || null;
      })

      .addCase(getDashboardOverview.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Dashboard laden mislukt.";
      });
  },
});

export const { clearDashboardError } = dashboardSlice.actions;

export default dashboardSlice.reducer;
